import React, { useContext, useEffect, useState } from 'react';
import useTheme from 'src/hooks/useTheme';
import useDictionary from 'src/hooks/useDictionary';
import SecurityAdvisorContext from 'src/context/SecurityAdvisorContext';
import BarLoader from 'react-bar-loader';
import { getEvents } from 'src/api/securityAdvisor';
import { notEmptyArray } from 'src/misc/Misc';
import CondensedTable from 'src/components/layout/CondensedTable';
import EventViewer from './EventViewer';
import { getEventListColumns } from '../../Misc/misc';
import SkeletonTable from 'src/components/layout/SkeletonTable';

//import PropTypes from 'prop-types';

var eventsWidgetCurrentPage = 1;
const EventsWidget = () => {
  const { eventWidgetItems, setEventWidgetItems, eventWidgetItemsForceReload, setEventWidgetItemsForceReload } = useContext(SecurityAdvisorContext);
  const { theme } = useTheme();
  const actionDictionary = useDictionary('sa-events-action');
  const entityTypeDictionary = useDictionary('sa-events-entitytype');

  const [loading, setLoading] = useState(false);
  const [pageSize] = useState(parseInt(5));
  const [thereIsMore, setThereIsMore] = useState(false);
  const [rerenderTable, setRerenderTable] = useState(false);
  const [clickedEvent, setClickedEvent] = useState(null);

  useEffect(() => {
    if (!eventWidgetItems) loadData();
  }, []);

  useEffect(() => {
    if (eventWidgetItemsForceReload) {
      eventsWidgetCurrentPage = 1;
      setRerenderTable(true);
      setThereIsMore(false);
      setEventWidgetItems(false);
      loadData();
    }
  }, [eventWidgetItemsForceReload]);

  useEffect(() => {
    setRerenderTable(true);
  }, [actionDictionary, entityTypeDictionary]);

  useEffect(() => {
    if (rerenderTable) setRerenderTable(false);
  }, [rerenderTable]);

  const loadData = async (loadMore = false) => {
    setLoading(true);
    try {
      const resp = await getEvents(eventsWidgetCurrentPage, pageSize);
      // const resp = await searchTenants(q?.length > 0 ? q : null, tenantsCurrentPage, pageSize);
      eventsWidgetCurrentPage++;
      setThereIsMore(resp?.length === pageSize ? true : false);
      if (true === notEmptyArray(resp)) {
        if (loadMore) setEventWidgetItems([...eventWidgetItems, ...resp]);
        else setEventWidgetItems(resp);
      } else {
        setEventWidgetItems([]);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
    setEventWidgetItemsForceReload(false);
  };

  return (
    <div>
      {loading ? <BarLoader color={theme.primary} backgroundColor={theme.light} height='2' width='100%' /> : <div style={{ height: '1px', marginTop: '1px', backgroundColor: 'transparent' }}></div>}
      {clickedEvent?.id && clickedEvent?.detail && <EventViewer eventId={clickedEvent.id} eventDetail={clickedEvent.detail} onClose={() => setClickedEvent(null)} />}
      <div className={loading ? 'disabled' : null}>
        {!eventWidgetItems ? (
          <SkeletonTable />
        ) : (
          <>
            {!rerenderTable && (
              <CondensedTable
                //loading={thereIsMore && loading}
                pagination={{
                  showSizeChanger: false,
                  pageSize,
                  total: thereIsMore ? eventWidgetItems?.length + 1 : eventWidgetItems?.length ?? 0,
                  onChange: (page, pageSize) => (thereIsMore && page > eventWidgetItems?.length / pageSize ? loadData(true) : null),
                }}
                rowKey={(record) => record.id}
                dataSource={eventWidgetItems}
                columns={getEventListColumns(actionDictionary, entityTypeDictionary)}
                size='small'
                onRow={(record) => ({
                  onClick: () => {
                    setClickedEvent({ id: record.id, detail: record.detail });
                  },
                })}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

EventsWidget.propTypes = {};

export default EventsWidget;
